import { createFeature, createReducer, on } from '@ngrx/store';
import { Features } from '@shared/models';
import { AuthActions } from '../auth-feature';
import { FeatureFlagActions } from './feature-flag.actions';

export type FeatureFlagState = Record<string, boolean>;

export const featureList: Features = {
  mockApiFeature: {
    name: 'Mock API Requests',
    environments: [],
  },
};

export const initialFeatureFlagState: FeatureFlagState = {};

export const featureFlagFeature = createFeature({
  name: 'featureFlag',
  reducer: createReducer(
    initialFeatureFlagState,
    on(FeatureFlagActions.setFeatureFlags, (state, { featureFlags }): FeatureFlagState => ({ ...state, ...featureFlags })),
    on(AuthActions.authLogoutCompleted, (): FeatureFlagState => ({ ...initialFeatureFlagState })),
  ),
});
